
    import '/opt/buildhome/repo/packages/x/docs/x-markdown/components-data.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-x-markdown-components-data-demo-datachart"],
  getter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/x-markdown/components-data.zh-CN.md?type=demo')
};